/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import type { Provider, TransactionRequest } from "@ethersproject/providers";
import type { PromiseOrValue } from "../../../common";
import type {
  NameServiceLogic,
  NameServiceLogicInterface,
} from "../../../contracts/nameService/NameServiceLogic";

const _abi = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    stateMutability: "payable",
    type: "fallback",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "keyName",
        type: "bytes32",
      },
    ],
    name: "getSingle",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "keyName",
        type: "bytes32",
      },
    ],
    name: "getSingleSafe",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "which",
        type: "address",
      },
    ],
    name: "isBlocked",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "keyName",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "which",
        type: "address",
      },
    ],
    name: "isMultiple",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "keyName",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "which",
        type: "address",
      },
    ],
    name: "isMultipleSafe",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "which",
        type: "address",
      },
    ],
    name: "isPrivileged",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "listMultipleEntries",
    outputs: [
      {
        components: [
          {
            internalType: "bytes32",
            name: "name",
            type: "bytes32",
          },
          {
            internalType: "address[]",
            name: "addr",
            type: "address[]",
          },
        ],
        internalType: "struct GenericNameServiceType.MultipleEntryRet[]",
        name: "",
        type: "tuple[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "listSingleEntries",
    outputs: [
      {
        components: [
          {
            internalType: "bytes32",
            name: "name",
            type: "bytes32",
          },
          {
            internalType: "address",
            name: "addr",
            type: "address",
          },
        ],
        internalType: "struct GenericNameServiceType.SingleEntryRet[]",
        name: "",
        type: "tuple[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newAssociatedOperator",
        type: "address",
      },
      {
        internalType: "bool",
        name: "flag",
        type: "bool",
      },
    ],
    name: "setAssociatedOperator",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "list",
        type: "address[]",
      },
      {
        internalType: "bool",
        name: "flag",
        type: "bool",
      },
    ],
    name: "setBlockList",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "keyName",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "which",
        type: "address",
      },
      {
        internalType: "bool",
        name: "enable",
        type: "bool",
      },
    ],
    name: "setMultiple",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32[]",
        name: "keyName",
        type: "bytes32[]",
      },
      {
        internalType: "address[]",
        name: "which",
        type: "address[]",
      },
      {
        internalType: "bool[]",
        name: "enable",
        type: "bool[]",
      },
    ],
    name: "setMultipleEntries",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "list",
        type: "address[]",
      },
      {
        internalType: "bool",
        name: "flag",
        type: "bool",
      },
    ],
    name: "setPrivilegedList",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "keyName",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "which",
        type: "address",
      },
      {
        internalType: "bool",
        name: "enable",
        type: "bool",
      },
    ],
    name: "setSingle",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32[]",
        name: "keyName",
        type: "bytes32[]",
      },
      {
        internalType: "address[]",
        name: "which",
        type: "address[]",
      },
      {
        internalType: "bool[]",
        name: "enable",
        type: "bool[]",
      },
    ],
    name: "setSingleEntries",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    stateMutability: "payable",
    type: "receive",
  },
] as const;

const _bytecode =
  "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";

type NameServiceLogicConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: NameServiceLogicConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class NameServiceLogic__factory extends ContractFactory {
  constructor(...args: NameServiceLogicConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override deploy(
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): Promise<NameServiceLogic> {
    return super.deploy(overrides || {}) as Promise<NameServiceLogic>;
  }
  override getDeployTransaction(
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  override attach(address: string): NameServiceLogic {
    return super.attach(address) as NameServiceLogic;
  }
  override connect(signer: Signer): NameServiceLogic__factory {
    return super.connect(signer) as NameServiceLogic__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): NameServiceLogicInterface {
    return new utils.Interface(_abi) as NameServiceLogicInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): NameServiceLogic {
    return new Contract(address, _abi, signerOrProvider) as NameServiceLogic;
  }
}
